import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { LicenseSettingListActions, LicenseSettingListActionTypes } from '../actions/license-setting-list.actions';
import {LicenseMgtList, LicenseSettingList} from '../license-mgt.model';

export interface State extends EntityState<LicenseSettingList> {
  Loaded: boolean;
  Loading: boolean;
}

export const adapter: EntityAdapter<LicenseSettingList> = createEntityAdapter<LicenseSettingList>({
  selectId: info => info.InfoId
});

export const initialState: State = adapter.getInitialState({
  Loaded: false,
  Loading: false
});

export function reducer(
  state = initialState,
  action: LicenseSettingListActions
): State {
  switch (action.type) {
    case LicenseSettingListActionTypes.AddLicenseSettingList: {
      return adapter.addOne(action.payload.licenseSettingList, state);
    }

    case LicenseSettingListActionTypes.UpsertLicenseSettingList: {
      return adapter.upsertOne(action.payload.licenseSettingList, state);
    }

    case LicenseSettingListActionTypes.AddLicenseSettingLists: {
      return adapter.addMany(action.payload.licenseSettingLists, state);
    }

    case LicenseSettingListActionTypes.UpsertLicenseSettingLists: {
      return adapter.upsertMany(action.payload.licenseSettingLists, state);
    }

    case LicenseSettingListActionTypes.UpdateLicenseSettingList: {
      return adapter.updateOne(action.payload.licenseSettingList, state);
    }

    case LicenseSettingListActionTypes.UpdateLicenseSettingLists: {
      return adapter.updateMany(action.payload.licenseSettingLists, state);
    }

    case LicenseSettingListActionTypes.DeleteLicenseSettingList: {
      return adapter.removeOne(action.payload.id, state);
    }

    case LicenseSettingListActionTypes.DeleteLicenseSettingLists: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case LicenseSettingListActionTypes.ClearLicenseSettingLists: {
      return adapter.removeAll(state);
    }

    case LicenseSettingListActionTypes.LoadLicenseSettingLists: {
      return adapter.setAll(action.payload, {
        ...state,
        Loaded: true,
        Loading: false
      });
    }

    case LicenseSettingListActionTypes.GetLicenseSettingLists: {
      return adapter.removeAll({
        ...state,
        Loaded: false,
        Loading: true
      });
    }

    case LicenseSettingListActionTypes.GetLicenseSettingListsFails: {
      return {...state, Loaded: true, Loading: false};
    }

    default: {
      return state;
    }
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
